"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24LogoGoogle = function Svg24LogoGoogle(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M12 6.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C16.46 3.89 14.43 3 12 3 8.48 3 5.44 5.02 3.96 7.96l2.91 2.26C7.6 8.05 9.62 6.48 12 6.48z",
    fill: useDefaultColors ? '#EA4335' : fill
  }), _react.default.createElement("path", {
    d: "M20.64 12.2c0-.74-.06-1.28-.19-1.84H12v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z",
    fill: useDefaultColors ? '#4285F4' : fill
  }), _react.default.createElement("path", {
    d: "M6.88 13.78a5.54 5.54 0 0 1-.3-1.78c0-.62.11-1.22.29-1.78L3.96 7.96A9.008 9.008 0 0 0 3 12c0 1.45.35 2.82.96 4.04l2.92-2.26z",
    fill: useDefaultColors ? '#FBBC05' : fill
  }), _react.default.createElement("path", {
    d: "M12 21c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74l-2.91 2.26C5.45 18.98 8.48 21 12 21z",
    fill: useDefaultColors ? '#34A853' : fill
  }));
};

Svg24LogoGoogle.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24LogoGoogle;
exports.default = _default;